// Canonical form for dedup matching against the resident's active register:
// case-insensitive with runs of whitespace collapsed. Shared by the add-modal
// warning, the AI-suggestion badges and any future dedup consumer so they all
// agree on what "the same name" means.
export const normalizeEquipmentName = (name) =>
  String(name ?? "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

export const CARE_PLAN_EQUIPMENT_FIELDS = {
  resident_id: "",
  rd_care_plan_id: "",
  equipment_catalogue_id: "",
  equipment_name: "",
  dependency_level: "",
  status: "provided",
  supplier: "",
  serial_no: "",
  service_due: "",
  mca_reference: "",
  notes: "",
};

export const buildCarePlanEquipmentPayload = ({
  resident_id = "",
  rd_care_plan_id = "",
  equipment_catalogue_id = "",
  equipment_name = "",
  dependency_level = "",
  status = "provided",
  supplier = "",
  serial_no = "",
  service_due = "",
  mca_reference = "",
  notes = "",
}) => {
  const trimmedName = String(equipment_name ?? "").trim();
  const catalogueId = equipment_catalogue_id || null;
  return {
    // The register is resident-level; every item is attached to a care plan.
    resident_id,
    rd_care_plan_id: rd_care_plan_id || null,
    equipment_catalogue_id: catalogueId,
    // Send free-text name only when no catalogue match was chosen.
    equipment_name: catalogueId ? null : trimmedName || null,
    dependency_level: dependency_level || null,
    // Items are usually recorded once already in use.
    status: status === "requested" ? "requested" : "provided",
    supplier: String(supplier).trim() || null,
    serial_no: String(serial_no).trim() || null,
    service_due: service_due || null,
    mca_reference: String(mca_reference).trim() || null,
    notes: String(notes).trim() || null,
  };
};

export const buildCarePlanEquipmentEditPayload = ({
  equipment_name,
  dependency_level = "",
  supplier = "",
  serial_no = "",
  service_due = "",
  mca_reference = "",
  notes = "",
}) => ({
  // Name is not nullable — only send it when actually renaming so callers
  // that edit other fields (e.g. inline dependence chips) can't blank it.
  ...(String(equipment_name ?? "").trim()
    ? { equipment_name: String(equipment_name).trim() }
    : {}),
  dependency_level: dependency_level || null,
  supplier: String(supplier).trim() || null,
  serial_no: String(serial_no).trim() || null,
  service_due: service_due || null,
  mca_reference: String(mca_reference).trim() || null,
  notes: String(notes).trim() || null,
});
